module.exports = __webpack_public_path__ + "static/media/hollow_bar_postinspect_tall.1978824f.svg";